// src/components/products/ProductForm/TransferDetailsSections/TransferOperatingHoursSection.jsx

import React from "react";
import { Grid } from "@mui/material";
import FormInput from "../../../inputs/FormInput";

const TransferOperatingHoursSection = ({
    formData,
    setFormData,
    errors,
    isArabic,
}) => {
    return (
        <Grid container spacing={3}>
            {/* Operating Hours Start Time */}
            <Grid item xs={12} md={6}>
                <FormInput
                    label={isArabic ? 'وقت بداية التشغيل' : 'Operating Hours Start Time'}
                    type="time"
                    name="operating_hours_start_time"
                    value={formData.operating_hours_start_time || ''}
                    onChange={(e) => setFormData({
                        ...formData,
                        operating_hours_start_time: e.target.value
                    })}
                    required
                    error={!!errors.operating_hours_start_time}
                    helperText={errors.operating_hours_start_time}
                />
            </Grid>

            {/* Operating Hours End Time */}
            <Grid item xs={12} md={6}>
                <FormInput
                    label={isArabic ? 'وقت نهاية التشغيل' : 'Operating Hours End Time'}
                    type="time"
                    name="operating_hours_end_time"
                    value={formData.operating_hours_end_time || ''}
                    onChange={(e) => setFormData({
                        ...formData,
                        operating_hours_end_time: e.target.value
                    })}
                    required
                    error={!!errors.operating_hours_end_time}
                    helperText={errors.operating_hours_end_time}
                />
            </Grid>
        </Grid>
    );
};

export default TransferOperatingHoursSection;
